import "./Toast.scss";

const Toast = ({ visible, message, type = "error", duration = 2000 }) => {
  return (
    <div className="toastWrapper">
      {visible && (
        <div className={`toast toast--${type}`}>
          {message}
          <div
            className="toast__progress"
            style={{ animationDuration: `${duration}ms` }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Toast;
